import React from 'react';

const TermsAndCondition = () => {
    return (
        <div className="pt-24 sm:pt-28 md:pt-36 pb-16 px-4 sm:px-6 md:px-12 lg:px-20 max-w-5xl mx-auto">
            <h1 className="tracking-wide font-thin md:font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-8 sm:mb-12">
                TERMS AND CONDITIONS FOR HAIDERIES REAL ESTATE LLC
            </h1>
            <div className="space-y-8 text-gray-700 leading-relaxed text-sm sm:text-base">
                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Introduction</h2>
                    <p className="mb-3">
                        Welcome to our website! These Website Standard Terms and Conditions, detailed on this webpage, are designed to govern your use of Website Name, which is accessible at Website.com.
                    </p>
                    <p>
                        By using this Website, you agree to comply with and be bound by these Terms. If you do not agree with any part of these Website Standard Terms and Conditions, please refrain from using the Website. Additionally, individuals under 18 years of age or minors are not permitted to use this Website.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Intellectual Property Rights</h2>
                    <p>
                        All intellectual property rights and materials contained on this Website, excluding your own content, are owned by Company Name and/or its licensors. You are granted a limited license for the sole purpose of viewing the material on this Website.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Restrictions</h2>
                    <p className="mb-3">You are expressly restricted from the following activities:</p>
                    <ul className="list-disc pl-5 space-y-1.5">
                        <li>Publishing Website material in any other media.</li>
                        <li>Selling, sublicensing, or commercializing any Website material.</li>
                        <li>Publicly performing or showing any Website material.</li>
                        <li>Using this Website in a manner that may be damaging to it.</li>
                        <li>Using this Website in a way that impacts user access.</li>
                        <li>Using this Website contrary to applicable laws and regulations.</li>
                        <li>Engaging in data mining, harvesting, extracting, or similar activities.</li>
                        <li>Using this Website for advertising or marketing.</li>
                    </ul>
                    <p className="mt-3">
                        Access to certain areas may be restricted by Company Name, and user IDs and passwords must be kept confidential.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Your Content</h2>
                    <p>
                        "Your Content" refers to any audio, video, text, images, or other material you choose to display on this Website. By displaying Your Content, you grant Company Name a non-exclusive, worldwide, irrevocable, sub-licensable license to use, reproduce, adapt, publish, translate, and distribute it in any media. Your Content must not violate any third-party rights, and Company Name reserves the right to remove it without notice.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">No Warranties</h2>
                    <p>
                        This Website is provided "as is," with no representations or warranties from Company Name. Nothing on this Website should be interpreted as advice.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Limitation of Liability</h2>
                    <p>
                        Company Name, its officers, directors, and employees shall not be liable for anything arising from or connected with your use of this Website, under contract or otherwise. Company Name shall not be held liable for any indirect, consequential, or special liability related to your use of this Website.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Indemnification</h2>
                    <p>
                        You agree to indemnify Company Name from any liabilities, costs, demands, causes of action, damages, and expenses arising from your breach of these Terms.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Severability</h2>
                    <p>
                        If any provision of these Terms is found to be invalid under applicable law, it shall be deleted without affecting the remaining provisions.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Variation of Terms</h2>
                    <p>
                        Company Name may revise these Terms at any time, and your continued use of the Website implies your agreement to review them regularly.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Assignment</h2>
                    <p>
                        Company Name can assign, transfer, and subcontract its rights and/or obligations under these Terms without notification, but you cannot do the same without permission.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Entire Agreement</h2>
                    <p>
                        These Terms constitute the entire agreement between Company Name and you regarding your use of this Website, superseding all prior agreements and understandings.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Governing Law & Jurisdiction</h2>
                    <p>
                        These Terms are governed by the laws of the State of Country, and you submit to the non-exclusive jurisdiction of state and federal courts in the Country for dispute resolution.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TermsAndCondition;
